<template lang="pug">
	//- Имя текущего чата с возможностью inline редактирования по клику на карандаш и удаления чата, а также доступный ИИ бюджет справа
	.ai-chat-title(v-if="chat || budgetDescription")
		.ai-chat-title-info(v-if="chat")
			template(v-if="!editingTitle")
				span.ai-chat-title-text {{chat.title}}
				i.fa.fa-pencil(v-on:click="startTitleEdit()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Rename chat'}")
			input.ai-chat-title-input(v-else ref="titleInput" type="text" v-model="editedTitle" maxlength="200" v-on:keydown.enter.prevent="saveTitle()" v-on:keydown.esc.prevent="cancelTitleEdit()" v-on:blur="saveTitle()")
			i.fa.fa-trash(v-if="!editingTitle" v-on:click="deleteChat($event)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Delete chat'}")
		.ai-chat-budget(v-if="budgetDescription" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Money you can spend on AI in this creative'}") Available AI budget: {{budgetDescription}}
</template>

<script>
	import { Server } 			from './../../services/Server'

	export default {
		name: "AIAgentChatTitle",
		// chat - текущий чат (null если чатов в версии ещё нет), budgetDescription - описание доступного ИИ бюджета креатива
		props: ['chat', 'budgetDescription'],
		data() {

			return {
				editingTitle: false,
				editedTitle: ''
			};

		},
		watch: {
			// При переключении чата редактирование имени прерывается
			'chat.id'() {

				this.editingTitle = false;

			}
		},
		methods: {
			startTitleEdit() {

				if (!this.chat) return;

				this.editedTitle = this.chat.title;
				this.editingTitle = true;

				this.$nextTick(() => {

					if (this.$refs.titleInput) {

						this.$refs.titleInput.focus();
						//this.$refs.titleInput.select();

					}

				});

			},
			saveTitle() {

				if (!this.editingTitle) return;

				this.editingTitle = false;

				let title = this.editedTitle.trim();

				if (!this.chat || !title || title === this.chat.title) return;

				Server.sendToServer({
					AiChatRename: {
						chatId: this.chat.id,
						title: title
					}
				});

			},
			cancelTitleEdit() {

				this.editingTitle = false;

			},
			deleteChat(e) {

				if (!this.chat) return;

				Broadcast.call('Show Confirm', [{
					caption: 'Delete chat',
					message: `Are you sure you want to delete chat "${this.chat.title}"?`,
					confirmButtonText: '&nbsp;&nbsp;Delete chat',
					confirmButtonIcon: 'fa-trash',
					forceConfirm: e?.shiftKey,
					confirmCallback: () => {

						Server.sendToServer({
							AiChatDelete: {
								chatId: this.chat.id
							}
						});

					}
				}]);

			}
		}
	}
</script>

<style lang="sass">

	.ai-chat
		.ai-chat-input
			// Имя текущего чата над textarea (высота одинаковая для текста и поля редактирования чтобы вёрстка не прыгала)
			.ai-chat-title
				display: flex
				flex-direction: row
				align-items: center
				gap: 8px
				height: 22px
				margin-top: 6px
				font-size: 13px
				color: #adb6bf

				.ai-chat-title-info
					display: flex
					flex-direction: row
					align-items: center
					gap: 4px
					min-width: 0

					&:hover
						i.fa-pencil, i.fa-trash
							opacity: 1

				.ai-chat-title-text
					font-weight: normal
					white-space: nowrap
					overflow: hidden
					text-overflow: ellipsis

				i.fa-pencil
					cursor: pointer
					color: #73818f
					opacity: 0
					transition: opacity 0.2s ease-in-out, color 0.2s ease-in-out
					font-size: 14px
					padding: 5px
					flex: 0 0 auto

					&:hover
						opacity: 1
						color: #20a8d8

				i.fa-trash
					cursor: pointer
					color: #73818f
					opacity: 0
					transition: opacity 0.2s ease-in-out, color 0.2s ease-in-out
					font-size: 14px
					padding: 5px
					flex: 0 0 auto

					&:hover
						opacity: 1
						color: #f86c6b

				.ai-chat-budget
					margin-left: auto
					font-size: 12px
					color: #73818f
					white-space: nowrap
					overflow: hidden
					text-overflow: ellipsis
					user-select: none

				.ai-chat-title-input
					width: 300px
					max-width: 100%
					height: 22px
					padding: 0
					font-size: 12px
					font-weight: bold
					color: #f3f4f5
					background-color: transparent
					border: transparent
					//border-radius: 0.25rem
					user-select: text

					&:focus
						outline: none
						box-shadow: none
						border-color: rgba(255, 255, 255, 0.3)

</style>
